"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isMobile = _interopRequireDefault(require("is-mobile"));

var _Input = _interopRequireDefault(require("./components/Input"));

var _Label = _interopRequireDefault(require("./components/Label")); // eslint-disable-line sort-imports


var Radio =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Radio, _Component);

  function Radio(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Radio);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Radio).call(this, props));
    _this.handleHover = _this.handleHover.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    var checked = props.checked;
    _this.state = {
      checked: checked || false,
      hovered: false,
      isMobile: (0, _isMobile.default)()
    };
    return _this;
  }

  (0, _createClass2.default)(Radio, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var checked = this.props.checked;
      var nextChecked = nextProps.checked;

      if (checked !== nextChecked) {
        this.setState({
          checked: nextChecked
        });
      }
    }
  }, {
    key: "handleHover",
    value: function handleHover(event, isHovered) {
      this.setState({
        hovered: isHovered
      });
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this2 = this;

      var _this$props = this.props,
          activeClass = _this$props.activeClass,
          aria = _this$props.aria,
          checkedClass = _this$props.checkedClass,
          className = _this$props.className,
          defaultChecked = _this$props.defaultChecked,
          disabled = _this$props.disabled,
          disabledClass = _this$props.disabledClass,
          focusClass = _this$props.focusClass,
          hoverClass = _this$props.hoverClass,
          id = _this$props.id,
          increaseArea = _this$props.increaseArea,
          indeterminate = _this$props.indeterminate,
          indeterminateClass = _this$props.indeterminateClass,
          inheritClass = _this$props.inheritClass,
          inheritID = _this$props.inheritID,
          insert = _this$props.insert,
          isMobile = _this$props.isMobile,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          radioClass = _this$props.radioClass,
          value = _this$props.value,
          checked = _this$props.checked,
          children = _this$props.children,
          determinateClass = _this$props.determinateClass,
          label = _this$props.label,
          labelClassName = _this$props.labelClassName,
          labelHover = _this$props.labelHover,
          labelHoverClass = _this$props.labelHoverClass,
          labelTag = _this$props.labelTag,
          labelTagClassName = _this$props.labelTagClassName,
          onMouseDown = _this$props.onMouseDown,
          onMouseLeave = _this$props.onMouseLeave,
          onMouseUp = _this$props.onMouseUp,
          onTouchEnd = _this$props.onTouchEnd,
          onTouchStart = _this$props.onTouchStart,
          type = _this$props.type,
          other = (0, _objectWithoutProperties2.default)(_this$props, ["activeClass", "aria", "checkedClass", "className", "defaultChecked", "disabled", "disabledClass", "focusClass", "hoverClass", "id", "increaseArea", "indeterminate", "indeterminateClass", "inheritClass", "inheritID", "insert", "isMobile", "name", "onBlur", "onChange", "onFocus", "radioClass", "value", "checked", "children", "determinateClass", "label", "labelClassName", "labelHover", "labelHoverClass", "labelTag", "labelTagClassName", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchStart", "type"]);
      var _this$state = this.state,
          stateChecked = _this$state.checked,
          hovered = _this$state.hovered;
      return _react.default.createElement(_Input.default, (0, _extends2.default)({}, other, {
        activeClass: activeClass,
        aria: aria,
        checked: stateChecked,
        checkedClass: checkedClass,
        className: className,
        defaultChecked: defaultChecked,
        disabled: disabled,
        disabledClass: disabledClass,
        focusClass: focusClass,
        hoverClass: hoverClass,
        hovered: hovered,
        id: id,
        increaseArea: increaseArea,
        indeterminate: indeterminate,
        indeterminateClass: indeterminateClass,
        inheritClass: inheritClass,
        inheritID: inheritID,
        inputType: "radio",
        insert: insert,
        isMobile: isMobile,
        name: name,
        radioClass: radioClass,
        ref: function ref(c) {
          _this2.input = c;
        },
        value: value,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          label = _this$props2.label,
          labelClassName = _this$props2.labelClassName,
          labelHover = _this$props2.labelHover,
          labelTag = _this$props2.labelTag,
          labelTagClassName = _this$props2.labelTagClassName;
      var isMobile = this.state.isMobile;

      if (!label && !children) {
        return this.renderInput();
      }

      return _react.default.createElement(_Label.default, {
        disabled: disabled,
        handleHover: this.handleHover,
        isMobile: isMobile,
        label: label,
        labelChildren: children,
        labelClassName: labelClassName,
        labelHover: labelHover,
        labelTag: labelTag,
        labelTagClassName: labelTagClassName
      }, this.renderInput());
    }
  }]);
  return Radio;
}(_react.Component);

(0, _defineProperty2.default)(Radio, "propTypes", {
  activeClass: _propTypes.default.string,
  aria: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  checkedClass: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  defaultChecked: _propTypes.default.bool,
  determinateClass: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  disabledClass: _propTypes.default.string,
  focusClass: _propTypes.default.string,
  hoverClass: _propTypes.default.string,
  id: _propTypes.default.string,
  increaseArea: _propTypes.default.string,
  indeterminate: _propTypes.default.bool,
  indeterminateClass: _propTypes.default.string,
  inheritClass: _propTypes.default.bool,
  inheritID: _propTypes.default.bool,
  insert: _propTypes.default.node,
  isMobile: _propTypes.default.bool,
  label: _propTypes.default.node,
  labelClassName: _propTypes.default.string,
  labelHover: _propTypes.default.bool,
  labelHoverClass: _propTypes.default.string,
  labelTag: _propTypes.default.string,
  labelTagClassName: _propTypes.default.string,
  name: _propTypes.default.string,
  radioClass: _propTypes.default.string,
  type: _propTypes.default.string,
  value: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  onTouchEnd: _propTypes.default.func,
  onTouchStart: _propTypes.default.func
});
(0, _defineProperty2.default)(Radio, "defaultProps", {
  activeClass: 'active',
  aria: false,
  checked: false,
  checkedClass: 'checked',
  children: null,
  className: null,
  defaultChecked: false,
  determinateClass: null,
  disabled: false,
  disabledClass: 'disabled',
  focusClass: 'focus',
  hoverClass: 'hover',
  id: null,
  increaseArea: '',
  indeterminate: true,
  indeterminateClass: 'indeterminate',
  inheritClass: false,
  inheritID: false,
  insert: null,
  isMobile: false,
  label: null,
  labelClassName: null,
  labelHover: true,
  labelHoverClass: 'hover',
  labelTag: 'span',
  labelTagClassName: null,
  name: null,
  radioClass: 'iradio',
  type: null,
  value: '',
  onBlur: null,
  onChange: null,
  onFocus: null,
  onMouseDown: null,
  onMouseLeave: null,
  onMouseUp: null,
  onTouchEnd: null,
  onTouchStart: null
});
var _default = Radio;
exports.default = _default;